<!-- @format -->

<template>
	<el-popover :visible="state.visible" :width="160">
		<p style="margin-top: 0">
			<el-icon type="QuestionFilled" class="el-popconfirm__icon" style="color: rgb(255, 153, 0)">
				<QuestionFilled />
			</el-icon>
			{{ title }}
		</p>
		<div style="text-align: right; margin: 0">
			<el-button size="small" :type="cancelButtonType" :loading="state.cancelLoading" @click="onCancel">
				{{ cancelButtonText }}
			</el-button>
			<el-button size="small" :type="confirmButtonType" :loading="state.confirmLoading" @click="onConfirm">
				{{ confirmButtonText }}
			</el-button>
		</div>
		<template #reference>
			<span @click="onClick">
				<slot name="reference" :disabled="disabled"></slot>
			</span>
		</template>
	</el-popover>
</template>

<script lang="ts" setup>
	interface Props {
		title: string;
		disabled?: boolean; // 是否可展示
		confirmButtonText?: string; // 确定按钮文案
		cancelButtonText?: string; // 取消按钮文案
		confirmButtonType?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'default';
		cancelButtonType?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'default';
	}

	const props = withDefaults(defineProps<Props>(), {
		disabled: false,
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		confirmButtonType: 'primary',
		cancelButtonType: 'default',
	});

	const emit = defineEmits(['confirm', 'cancel']);

	const state = ref({
		visible: false,
		confirmLoading: false,
		cancelLoading: false,
	});

	const onClick = () => {
		if (!props.disabled) state.value.visible = true;
	};

	const onConfirm = () => {
		state.value.confirmLoading = true;

		emit('confirm', () => {
			state.value.confirmLoading = false;
			state.value.visible = false;
		});
	};

	const onCancel = () => {
		state.value.cancelLoading = true;

		// @ts-ignore
		if (emit('cancel')) {
			emit('cancel', () => {
				state.value.cancelLoading = false;
				state.value.visible = false;
			});
		} else {
			state.value.cancelLoading = false;
			state.value.visible = false;
		}
	};
</script>
